<template>
  <div>
    <div class="majorTitle">
      Account Details <span><a
        style="font-size: 16px; font-weight: 400;"
        class="cursorPointer"
        @click="editAccount()"
      >[Edit Account]</a></span>
    </div>
    <div class="row">
      <div class="six columns marginLargeBottom">
        <div class="minorTitle paddingSmallBottom">
          Name
        </div>
        <div>
          {{ customer.display_name }}
        </div>
      </div>
      <div class="six columns marginLargeBottom">
        <div class="minorTitle paddingSmallBottom">
          Street Address
        </div>
        <div>
          {{ customer.billing_street_address }}<br>
          {{ customer.billing_city }}, {{ customer.billing_state }} {{ customer.billing_zip }}<br>
          {{ customer.billing_country }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="six columns marginLargeBottom">
        <div class="minorTitle paddingSmallBottom">
          Email Address
        </div>
        <div>
          {{ customer.email }}
        </div>
      </div>
      <div class="six columns marginLargeBottom">
        <div class="minorTitle paddingSmallBottom">
          Phone
        </div>
        <div>
          {{ customer.phone }}
        </div>
      </div>
    </div>
    <div class="majorTitle">
      Account Security
    </div>
    <div class="row">
      <div class="five columns">
        <div class="paddingSmallBottom">
          <transition
            name="fade"
            mode="out-in"
          >
            <span v-if="!showPasswordInput">
              <a
                class="navLink"
                @click="setShowPasswordInput(true)"
              >Update Password</a>
            </span>
            <span v-else>
              New Password
            </span>
          </transition>
        </div>
        <transition
          name="fade"
          mode="out-in"
        >
          <div
            v-if="!showPasswordInput"
            class="fontLarge"
          >
            ************
          </div>
          <div v-else>
            <div class="row">
              <div class="seven columns">
                <input
                  id="password"
                  ref="new_password"
                  v-model="password"
                  type="password"
                  name="password"
                  required
                  placeholder=""
                >
              </div>
              <div class="three columns">
                <button
                  v-if="(typeof (apiPending.update_password) !== 'undefined')"
                  class="disabledButton bidButton"
                  disabled="disabled"
                >
                  <span class="loading" />
                </button>
                <button
                  v-else-if="password.length < 8"
                  class="bidButton disabledButton"
                >
                  Save
                </button>
                <button
                  v-else-if="password.length > 0"
                  type="submit"
                  class="bidButton backgroundColorDefault"
                  @click="updatePassword('update_password')"
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </transition>
        <ApiResponse
          :context="'update_password'"
          :custom-message="customMessage"
        />
      </div>

      <div class="five columns">
        <a
          class="cursorPointer"
          @click="manageTwoFactorAuth()"
        >Two Factor Authentication</a>
      </div>
    </div>

    <div>
      <div class="majorTitle">
        Tax Exemption Status
      </div>
      <div class="row">
        <div class="tax-container">
          <div class="row">
            <span class="tax-logo" /> <span class="tax-text"><a
              class="cursorPointer"
              @click="showUploadCertificateForm()"
            >View, add, or update certificate</a></span>
          </div>
        </div>
      </div>
    </div>

    <div v-if="canViewPayments()">
      <div v-if="customer.cc.length > 0">
        <div class="majorTitle">
          Payment Methods <span><a
            style="font-size: 16px; font-weight: 400;"
            class="cursorPointer"
            @click="editPaymentMethods()"
          >[Edit Payment Methods]</a></span>
        </div>

        <div>
          <div>{{ customer.cc[0].type }}</div>
          <div>Ending in {{ customer.cc[0].last_four }}</div>
          <div>Expiration {{ customer.cc[0].expire_month }} / {{ customer.cc[0].expire_year }}</div>
        </div>
      </div>
      <div v-else>
        <div class="majorTitle">
          Payment Methods
        </div>
        A credit card will be needed to register bids. You may upload a credit card <a
          class="cursorPointer"
          @click="editPaymentMethods()"
        >here</a>.
      </div>
    </div>
  </div>
</template>

<script>
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
import ApiResponse from '@/components/ApiResponse.vue'

export default {
	name: 'NotificationsCard',
	components: {
		VuePhoneNumberInput,
		ApiResponse
	},
	data () {
		return {
			'showPasswordInput': false,
			'password': '',
			'twoFactorPhoneNumber': '',
			'verificationCode': '',
			'askForVerificationCode': false,
			'phoneNumberIsValid': false,
			'uploadingCertificate': false
		}
	},
	computed: {
		apiPending: function () {
			return this.$store.getters.apiPending
		},
		customer: function () {
			return this.$store.getters.customer
		},
		customMessage: function () {
			if (this.showPasswordInput && this.password.length < 8) {
				return 'The new password must be at least 8 characters long.'
			}
		},
		verificationCodeIsValid: function () {
			if (this.verificationCode.length === 6) {
				return true
			}
			return false
		}
	},
	mounted () {
	},
	methods: {
		manageTwoFactorAuth: function () {
			// Set our current location as an exit-referrer in localstorage for all of the exit buttons.
			localStorage.setItem('exit-referrer', window.location.href)
			window.location.href = '/manage-authentication'
		},
		canViewPayments: function () {
			if (this.customer.international === true) {
				return false
			}

			return true
		},
		customerBlacklisted: function () {
			if (this.customer && this.customer.whiteblacklist !== 'blacklist') {
				return false
			}

			return true
		},
		checkPhoneNumber (payload) {
			this.phoneNumberIsValid = payload.isValid
			this.twoFactorFormattedPhoneNumber = payload.formatInternational
		},
		setShowPasswordInput (payload) {
			let context = 'update_password'
			this.$store.dispatch('clearApiResponse', context)
			this.showPasswordInput = payload
			this.$nextTick(function () {
				this.$refs.new_password.focus()
			})
		},
		verifyTwoFactorPhoneNumber () {
			let payload = {
				'verification_code': this.verificationCode,
				'phone_number': this.twoFactorFormattedPhoneNumber,
				'context': 'submit_verification_code'
			}
			this.$store.dispatch('verifyTwoFactorPhoneNumber', payload).then(() => {
				this.askForVerificationCode = false
				this.$store.dispatch('clearApiResponse', 'submit_verification_code')
				this.$store.dispatch('clearApiResponse', 'add_two_factor_phone_number')
			})
		},
		addTwoFactorPhoneNumber () {
			let payload = {
				'phone_number': this.twoFactorFormattedPhoneNumber,
				'is_primary': (this.customer.two_factor_primary_phone_number.length === 0),
				'context': 'add_two_factor_phone_number'
			}
			this.$store.dispatch('addTwoFactorPhoneNumber', payload).then(() => {
				this.askForVerificationCode = true
			})
		},
		updatePassword () {
			let payload = {
				'password': this.password,
				'context': 'update_password'
			}
			this.$store.dispatch('updatePassword', payload).then(() => {
				this.password = ''
				this.showPasswordInput = false
			})
		},
		showUploadCertificateForm () {
			window.location.href = '/cert-capture'
		},
		showUploadCertificateDialog () {
			this.showCertUploadRedirectConfirmation = !this.showCertUploadRedirectConfirmation
		},
		redirectToCertCapture () {
			window.location.href = 'https://app.certexpress.com/?c=3352537246434f3367344831426267653848493d'
		},
		editAccount () {
			// Set our current location as an exit-referrer in localstorage for all of the exit buttons.
			localStorage.setItem('exit-referrer', window.location.href)
			window.location.href = '/edit-account'
		},
		editPaymentMethods () {
			// Set our current location as an exit-referrer in localstorage for all of the exit buttons.
			localStorage.setItem('exit-referrer', window.location.href)
			window.location.href = '/payment-methods'
		}
	}
}

</script>

<style scoped>
.button-turn-on{
	background-color: #007AFF;
    color: white;
    border: 1px solid #007AFF;
    border-radius: 8px;
}
</style>
